import { Locale } from 'chaika-enums';
export const allergy = {
    patientDoesntHavePartOne: {
        [Locale.Ru]: 'У этого пациента нет зафиксированых',
        [Locale.Am]: 'Այս պացիենտի մոտ գրանցված չեն',
        [Locale.En]: 'This patient has no fixed',
        [Locale.Pt]: 'Este paciente não tem fixo',
        [Locale.Ge]: 'ამ პაციენტს არანაირი გამოსწორება არ აქვს',
    },
    patientDoesntHavePartTwo: {
        [Locale.Ru]: 'лекарственных непереносимостей',
        [Locale.Am]: 'դեղորայքային անհանդուրժողականություններ',
        [Locale.En]: 'drug intolerances',
        [Locale.Pt]: 'intolerâncias a medicamentos',
        [Locale.Ge]: 'ნარკოტიკების შეუწყნარებლობა',
    },
    patientDoesntHavePartThree: {
        [Locale.Ru]: 'аллергических реакций',
        [Locale.Am]: 'ալերգիկ ռեակցիաներ',
        [Locale.En]: 'allergic reactions',
        [Locale.Pt]: 'reações alérgicas',
        [Locale.Ge]: 'ალერგიული რეაქციები',
    },
    addMore: {
        [Locale.Ru]: 'Добавить ещё одну',
        [Locale.Am]: 'Ավելացնել ևս մեկը',
        [Locale.En]: 'Add another one',
        [Locale.Pt]: 'Adicionar outro',
        [Locale.Ge]: 'დაამატე კიდევ ერთი',
    },
    intolerance: {
        [Locale.Ru]: 'Непереносимость',
        [Locale.Am]: 'Անհանդուրժողականություն',
        [Locale.En]: 'Intolerance',
        [Locale.Pt]: 'Intolerância',
        [Locale.Ge]: 'შეუწყნარებლობა',
    },
    allergyTypeTwo: {
        [Locale.Ru]: 'Аллергию',
        [Locale.Am]: 'Ալերգիա',
        [Locale.En]: 'Allergy',
        [Locale.Pt]: 'Alergia',
        [Locale.Ge]: 'ალერგია',
    },
    drugIntolerance: {
        [Locale.Ru]: 'Лекарственная непереносимость',
        [Locale.Am]: 'Դեղորայքային անհանդուրժողականություն',
        [Locale.En]: 'Drug intolerance',
        [Locale.Pt]: 'Intolerância a medicamentos',
        [Locale.Ge]: 'ნარკოტიკების შეუწყნარებლობა',
    },
    allergy: {
        [Locale.Ru]: 'Аллергия',
        [Locale.Am]: 'Ալերգիա',
        [Locale.En]: 'Allergy',
        [Locale.Pt]: 'Alergia',
        [Locale.Ge]: 'ალერგია',
    },
    drug: {
        [Locale.Ru]: 'Препарат',
        [Locale.Am]: 'Պրեպարատ',
        [Locale.En]: 'Drug',
        [Locale.Pt]: 'Medicamento',
        [Locale.Ge]: 'ნარკოტიკი',
    },
    drugTwo: {
        [Locale.Ru]: 'Препарата',
        [Locale.Am]: 'Պրեպարատ',
        [Locale.En]: 'Drugs',
        [Locale.Pt]: 'Medicamentos',
        [Locale.Ge]: 'ნარკოტიკი',
    },
    drugs: {
        [Locale.Ru]: 'Препаратов',
        [Locale.Am]: 'Պրեպարատներ',
        [Locale.En]: 'Drugs',
        [Locale.Pt]: 'Medicamentos',
        [Locale.Ge]: 'ნარკოტიკი',
    },
    medications: {
        [Locale.Ru]: 'Медикаменты',
        [Locale.Am]: 'Դեղամիջոցներ',
        [Locale.En]: 'Medications',
        [Locale.Pt]: 'Medicamentos',
        [Locale.Ge]: 'ნარკოტიკები',
    },
    allergen: {
        [Locale.Ru]: 'Аллерген',
        [Locale.Am]: 'Ալերգեն',
        [Locale.En]: 'Allergen',
        [Locale.Pt]: 'Alérgeno',
        [Locale.Ge]: 'ალერგენი',
    },
    reactionType: {
        [Locale.Ru]: 'Тип реакции',
        [Locale.Am]: 'Ռեակցիայի տեսակ',
        [Locale.En]: 'Reaction type',
        [Locale.Pt]: 'Tipo de reação',
        [Locale.Ge]: 'რეაქციის ტიპი',
    },
    allergyType: {
        [Locale.Ru]: 'Вид аллергии',
        [Locale.Am]: 'Ալերգիայի տեսակ',
        [Locale.En]: 'Type of allergy',
        [Locale.Pt]: 'Tipo de alergia',
        [Locale.Ge]: 'ალერგიის ტიპი',
    },
    allergies: {
        [Locale.Ru]: 'Аллергии',
        [Locale.Am]: 'Ալերգիաներ',
        [Locale.En]: 'Allergies',
        [Locale.Pt]: 'Alergias',
        [Locale.Ge]: 'ალერგიები',
    },
    drugAllergy: {
        [Locale.Ru]: 'Лекарственная непереносимость',
        [Locale.Am]: 'Դեղորայքային անհանդուրժողականություն',
        [Locale.En]: 'Drug allergy',
        [Locale.Pt]: 'Alergia a medicamentos',
        [Locale.Ge]: 'ნარკოტიკის ალერგია',
    },
    noReactionType: {
        [Locale.Ru]: 'Тип реакции не указан',
        [Locale.Am]: 'Ռեակցիայի տեսակը նշված չէ',
        [Locale.En]: 'Reaction type not specified',
        [Locale.Pt]: 'Tipo de reação não especificado',
        [Locale.Ge]: 'Reaction type not specified',
    },
    noAllergy: {
        [Locale.Ru]: 'Аллергии нет',
        [Locale.Am]: 'Ալերգիա չկա',
        [Locale.En]: 'No allergies',
        [Locale.Pt]: 'Sem alergias',
        [Locale.Ge]: 'არ არის ალერგიები',
    },
    noDrugAllergy: {
        [Locale.Ru]: 'Непереносимостей нет',
        [Locale.Am]: 'Անհանդուրժողականություններ չկան',
        [Locale.En]: 'No drug allergies',
        [Locale.Pt]: 'Sem alergias a medicamentos',
        [Locale.Ge]: 'არ არის ნარკოტიკის ალერგიები',
    },
    noDrugAllergySecond: {
        [Locale.Ru]: 'Лекарственных непереносимостей нет',
        [Locale.Am]: 'Դեղորայքային անհանդուրժողականություններ չկան',
        [Locale.En]: 'No drug allergies',
        [Locale.Pt]: 'Sem alergias a medicamentos',
        [Locale.Ge]: 'არ არის ნარკოტიკის ალერგიები',
    },
    notFilledEarlier: {
        [Locale.Ru]: 'Не заполнялось ранее',
        [Locale.Am]: 'Նախկինում չի լրացվել',
        [Locale.En]: 'Not filled earlier',
        [Locale.Pt]: 'Não preenchido anteriormente',
        [Locale.Ge]: 'ადრე არ იყო შევსებული',
    },
    currentlyTaking: {
        [Locale.Ru]: 'Принимается в настоящее время',
        [Locale.Am]: 'Ընդունվում է ներկայումս',
        [Locale.En]: 'Currently taking',
        [Locale.Pt]: 'Tomando atualmente',
        [Locale.Ge]: 'ახალი დროის შესრულება',
    },
    issuedOnThisVisit: {
        [Locale.Ru]: 'Выданы на этом приёме',
        [Locale.Am]: 'Տրվել են այս ընդունելության ժամանակ',
        [Locale.En]: 'Issued on this visit',
        [Locale.Pt]: 'Emitido nesta visita',
        [Locale.Ge]: 'ახალი დროის შესრულება',
    },
    scheduleMeetingWithThePatientToMonitorTheCondition: {
        [Locale.Ru]: 'Запланируйте связь с пациентом, чтобы проконтролировать состояние:',
        [Locale.Am]: 'Պլանավորեք կապը պացիենտի հետ՝ վիճակը վերահսկելու համար՝',
        [Locale.En]: 'Schedule a meeting with the patient to monitor the condition:',
        [Locale.Pt]: 'Agende uma conversa com o paciente para monitorar a condição:',
        [Locale.Ge]: 'Schedule a meeting with the patient to monitor the condition:',
    },
};
